var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 0.083374C4.74992 0.083374 0.083252 4.75004 0.083252 10.5C0.083252 16.25 4.74992 20.9167 10.4999 20.9167C16.2499 20.9167 20.9166 16.25 20.9166 10.5C20.9166 4.75004 16.2499 0.083374 10.4999 0.083374ZM10.4999 3.20837C12.2291 3.20837 13.6249 4.60421 13.6249 6.33337C13.6249 8.06254 12.2291 9.45837 10.4999 9.45837C8.77075 9.45837 7.37492 8.06254 7.37492 6.33337C7.37492 4.60421 8.77075 3.20837 10.4999 3.20837ZM10.4999 18C9.26227 18 8.04386 17.6938 6.95333 17.1085C5.86281 16.5233 4.93406 15.6772 4.24992 14.6459C4.28117 12.573 8.41658 11.4375 10.4999 11.4375C12.5728 11.4375 16.7187 12.573 16.7499 14.6459C16.0658 15.6772 15.137 16.5233 14.0465 17.1085C12.956 17.6938 11.7376 18 10.4999 18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.b7ad64e7f1de6978fc8ba4a4eb338104.svg";
export { ForwardRef as ReactComponent };